import { Autocomplete } from "@mixitone/components";
import SearchIcon from "@mixitone/icons/search.svg";
import { ClubPlayer } from "@mixitone/models";
import type { List } from "@mixitone/oom";
import ClubPlayerFormController from "components/Forms/ClubPlayerFormController";
import type { CustomComponentFieldProps } from "components/Forms/FormFieldsDefinition";

const PlayerSearchField: React.FC<CustomComponentFieldProps<ClubPlayer>> = ({ ...props }) => {
  const controller = ClubPlayerFormController.use();
  const { clubPlayers } = controller.state;

  return (
    <Autocomplete
      className="w-full flex-grow bg-transparent py-2 pl-7 text-sm focus:outline-none"
      {...props}
      suggestions={clubPlayers as List<ClubPlayer>}
      onSelect={(player: ClubPlayer) => {
        controller.actionSearchSelect(player);
      }}
      blankSuggestion={new ClubPlayer({ name: "Register new player" })}
      renderSuggestion={(player) => player.name!}
      prefix={<SearchIcon className="w-[14px] stroke-gray-600" />}
      data-1p-ignore
      autoFocus={controller.props.autoFocus}
      error={controller.state.errors?.name}
    />
  );
};

export default PlayerSearchField;
